module.exports = __webpack_public_path__ + "media/images/sqra-logo-white-1fde2d42ae253452adb9a62bbedbc923.png";